import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const useStyles = createUseStyles((theme: Theme) => ({
  card: {
    background: 'white',
    border: '1px solid #E0E3E7',
    borderRadius: 8,
    padding: 25,
    display: 'flex',
    flexDirection: 'column'
  },
  clickable: {
    cursor: 'pointer',
    transition: 'border-color 0.15s, box-shadow 0.15s',
    '&:hover': {
      borderColor: '#c9cedb',
      boxShadow: '0 2px 8px rgba(58, 63, 88, 0.06)'
    }
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
    flexWrap: 'wrap'
  },
  subtitle: {
    fontSize: '0.9rem',
    fontWeight: 600,
    margin: 0
  },
  panel: {
    marginTop: 12,
    padding: '26px 20px',
    background: '#f8f9fb',
    border: '1px solid #ededed',
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: '12px',
    flexGrow: 1
  },
  panelIcon: {
    fontSize: 28
  },
  panelText: {
    color: '#6A728F',
    fontSize: '0.8rem',
    margin: 0
  },
  panelSubText: {
    color: '#9aa0b8',
    fontSize: '0.75rem',
    margin: 0,
    marginTop: -6
  },
  actions: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: 2
  }
}));

type Props = {
  title: string;
  icon: IconProp;
  iconColor: string;
  text: React.ReactNode;
  subText?: React.ReactNode;
  headerAction?: React.ReactNode;
  action?: React.ReactNode;
  onClick?: () => void;
};

// The "white card with a grey panel inside" motif from the delegate
// background check card. Pass onClick to make the whole card open a modal.
export default function SectionCard({
  title,
  icon,
  iconColor,
  text,
  subText,
  headerAction,
  action,
  onClick
}: Props) {
  const classes = useStyles();

  return (
    <div
      className={`${classes.card} ${onClick ? classes.clickable : ''}`}
      onClick={onClick}
    >
      <div className={classes.cardHeader}>
        <p className={classes.subtitle}>{title}</p>
        {headerAction}
      </div>
      <div className={classes.panel}>
        <FontAwesomeIcon
          icon={icon}
          className={classes.panelIcon}
          style={
            {
              color: iconColor,
              '--fa-primary-color': iconColor,
              '--fa-secondary-color': iconColor
            } as any
          }
        />
        <p className={classes.panelText}>{text}</p>
        {subText && <p className={classes.panelSubText}>{subText}</p>}
        {action && <div className={classes.actions}>{action}</div>}
      </div>
    </div>
  );
}
